import { render, staticRenderFns } from "./OnlineReservationSettingExampleModal.vue?vue&type=template&id=551e58e4&lang=pug"
import script from "./OnlineReservationSettingExampleModal.vue?vue&type=script&lang=ts"
export * from "./OnlineReservationSettingExampleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports